
class AllCheckBoxesSelector {

    init() {
        this.listenSelectAll();
    }

    listenSelectAll() {
        const selectAll = document.getElementById('select_all_checkboxes');
        if (selectAll) {
            selectAll.addEventListener('click', event => {
                let checkboxes = document.getElementsByName(selectAll.dataset.checkboxesNames);
                for (let i = 0, n = checkboxes.length; i < n; i++) {
                    checkboxes[i].checked = selectAll.checked;
                }
            });
        }

        $('.select_all_checkboxes').on('click', function() {
            let self = $(this);
            let name = self.data('checkboxes-names');
            let checkboxes = $('input[name="' + name + '"]');
            let parent = this;
            $(checkboxes).each(function(index, checkbox) {
                if ($(checkbox).is(":visible")) {
                    $(checkbox).prop('checked', self.is(':checked'));
                }
            })
        });
    }
}

module.exports = AllCheckBoxesSelector;